module.exports = __webpack_public_path__ + "assets/img/22.544ae2d3.png";